import { useMutation } from '@tanstack/react-query';

import { notificationService } from 'services';

export const useReadAllNotifications = () => {
  const { mutateAsync: readAll } = useMutation({
    mutationFn: () => notificationService.readAllNotifications(),
  });

  return { readAll };
};
